import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-model-description-footer', 
  templateUrl: './model-description-footer.component.html',
  styleUrls: ['./model-description-footer.component.scss']
})
export class ModelDescriptionFooterComponent implements OnInit {
  btnTextShow: string = 'Read More';
  btnTextHide: string = 'Read Less';
  btnText: string = this.btnTextShow;
  constructor() { }

  ngOnInit() {
  }
  readContent(): void {
    if (this.btnText === this.btnTextShow) {
      this.btnText = this.btnTextHide;
    }
    else {
      this.btnText = this.btnTextShow;
    }
  }
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/model-description-footer/model-description-footer.component.ts